module.exports = __webpack_public_path__ + "img/pro-m-slider23.f645ed38.jpg";